// Enlaces oficiales de las tiendas.
export const GOOGLE_PLAY_URL = 'https://play.google.com/store/apps/details?id=co.automarketcolombia.app';
export const APP_STORE_URL = 'https://apps.apple.com/co/app/id6823668217';

export function detectPlatform(ua = navigator.userAgent || '') {
  if (/android/i.test(ua)) return 'android';
  const iPadOS = /Macintosh/.test(ua) && navigator.maxTouchPoints > 1;
  if (/iPhone|iPad|iPod/i.test(ua) || iPadOS) return 'ios';
  return 'other';
}
